export default __webpack_public_path__ + "3e3562299c79f1f598a12594ce94a8d2.png";